import {GET_CODE_API_DEFAULT_DATA} from '@base/constants/common';
import {addOrderTagToParams, SIGN_UP_PATH} from '@base/constants/signUpPathSource';
import api from '~/api';
import {mapState} from 'vuex';
import qs from 'qs';

const SIGN_UP_CLICK = 7966029772384256;
const MODAL_VIEW = 5311254562105344;
// 轮询一次的时间间隔
const POLLING_TIME = 500;

// 压测时间
const MAX_TIMW = 5000;

export default {
    data() {
        return {
            wxTipPollingTime: null,
            divideIntoClassLoading: false,
            maxTimer: null,
            stopPolling: false,
            returnData: {},
            isFetching: false,
            clazzNumber: ''
        };
    },
    computed: {
        ...mapState({
            token: state => state.token,
            projectName: state => state.projectName,
        }),
        isGtqscz() {
            return this.projectName === 'gtqscz';
        },
    },
    methods: {

        /**
         * 一键报名公共方法
         * @param {Object} param.courseInfo 课程信息
         * @param {function} param.callback 报名成功的回调函数
         * @param {Boolean} param.isGetCode 是否执行取码任务
         */
        createOrderForFreeCourse({courseInfo = {}, callback, callbackParam = '', isGetCode = true, source = ''}) {
            if (this.token) {
                const {
                    clazzId,
                    courseType
                } = courseInfo;
                const params = {
                    productId: clazzId,
                    courseType,
                    channel: 2,
                    checkNotPayOrder: true,
                    isFromH5: false,
                };

                addOrderTagToParams(params, source);
                this.isFetching = true;
                const openCourseSignupCode = 445;
                this.$axios.$post(api.order.createForFreeCourse, qs.stringify(params)).then(res => {
                    this.isFetching = false;
                    if (res.status === openCourseSignupCode) {
                        this.clazzNumber = res.data?.orderInfos?.[0]?.clazzNumber;
                        this.$habo.haboClickReport(SIGN_UP_CLICK, {
                            source: source || SIGN_UP_PATH.SIGN_UP_PATH_CATEGORY
                        });
                        this.$habo.haboClickReport(MODAL_VIEW, {
                            source: '一键报名'
                        });
                        // 是否执行回调函数
                        if (typeof callback === 'function') {
                            callback(callbackParam);
                        }
                        // 是否执行取码任务
                        if (isGetCode) {
                            // 从订单接口拿到订单号
                            this.$modal.show('signup-modal');
                            const {order_id: orderId = ''} = res.data;
                            this.handlePolling(this.getCode, orderId);
                        }
                        return;
                    }
                    if (typeof callback === 'function') {
                        callback(callbackParam, false);
                    }
                })
                    .catch(error => {
                        this.isFetching = false;
                        console.log(error);
                        if (typeof callback === 'function') {
                            callback(callbackParam, false);
                        }
                    });
            }
        },
        // 轮询
        handlePolling(fn, orderId) {
            // 如果wxTipPollingTimer存在，清除并赋初值
            if (this.wxTipPollingTimer) {
                clearTimeout(this.wxTipPollingTimer);
                this.wxTipPollingTimer = null;
                this.divideIntoClassLoading = false;
            }
            // 如果maxTimer存在，清除并赋初值
            if (this.maxTimer) {
                clearTimeout(this.maxTimer);
                this.maxTimer = null;
                this.stopPolling = false;
            }
            // 开启加载
            this.divideIntoClassLoading = true;
            // 开启最大压测时间计时
            this.maxTimer = setTimeout(() => {
                // 到压测时间，轮询结束标志为true，关闭loading
                this.stopPolling = true;
                this.divideIntoClassLoading = false;
                // 特殊情况处理，第一次接口penging中，超过设定的压测时间，返回前端设置的默认值
                if (this.isEmpty(this.returnData)) {
                    this.returnData = GET_CODE_API_DEFAULT_DATA;
                }
                clearTimeout(this.maxTimer);
            }, MAX_TIMW);
            // 第一次轮询请求接口
            this.wxTipPollingTimer = setTimeout(() => {
                fn(orderId);
            }, POLLING_TIME);
        },
        getCode(orderId) {
            if (this.stopPolling) {
                clearTimeout(this.wxTipPollingTimer);
                if (this.isEmpty(this.returnData)) {
                    this.returnData = GET_CODE_API_DEFAULT_DATA;
                }
                this.divideIntoClassLoading = false;
                if (this.isGtqscz) {
                    this.signUpModalCloseHandler();
                    this.$toasted.show(
                        '恭喜您预约并分班完成', {
                            position: 'top-center',
                            duration: 1500,
                        }
                    )
                }
                return;
            }
            const params = {
                grade: this.grade,
                orderId,
                // 1:PC  2:M站免费公开课  3:M站付费公开课
                codeEnum: 1,
                courseId: this.courseId
            };
            const options = {params: {os: 'h5-pc'}};
            this.$axios.$post(api.order.getPublicClassQrCode, qs.stringify(params), options).then(res => {
                clearTimeout(this.wxTipPollingTimer);
                // 添加 !this.stopPolling 防止已经请求出去的接口pending中，超过压测时间返回值覆盖已有的值
                if (res.code === 0 && !this.stopPolling) {
                    // data 有{} 的情况。
                    this.returnData = this.isEmpty(res.data)
                        ? this.returnData
                        : {
                            ...this.returnData,
                            QRCode: res.data.QRCode,
                            display: res.data.display,
                            source: res.data.source
                        };
                    // 后端告诉结束标志，关闭loading，结束轮询
                    if (res.data.finalStatus === 1) {
                        this.divideIntoClassLoading = false;
                        if (this.isGtqscz) {
                            this.signUpModalCloseHandler();
                            this.$toasted.show(
                                '恭喜您预约并分班完成', {
                                    position: 'top-center',
                                    duration: 1500,
                                }
                            )
                        }
                    }
                    else {
                        this.wxTipPollingTimer = setTimeout(() => {
                            this.getCode(orderId);
                        }, POLLING_TIME);
                    }
                }
                // code 不为0的情况，启动下一次轮询。
                else {
                    this.wxTipPollingTimer = setTimeout(() => {
                        this.getCode(orderId);
                    }, POLLING_TIME);
                }
            })
                .catch(() => {
                    clearTimeout(this.wxTipPollingTimer);
                    // 是否过了压测时间，没有则继续轮询
                    if (this.stopPolling) {
                        if (this.isEmpty(this.returnData)) {
                            this.returnData = GET_CODE_API_DEFAULT_DATA;
                        }
                        this.divideIntoClassLoading = false;
                    }
                    else {
                        this.wxTipPollingTimer = setTimeout(() => {
                            this.getCode(orderId);
                        }, POLLING_TIME);
                    }
                });
        },
        // 判断是否为空对象
        isEmpty(data) {
            return Object.keys(data).length === 0;
        },
        signUpModalCloseHandler() {
            this.$modal.hide('signup-modal');
            this.hadnleStopPolling();
        },
        hadnleStopPolling() {
            this.stopPolling = true;
            this.divideIntoClassLoading = false;
            // 特殊情况处理，第一次接口penging中，超过设定的压测时间，返回前端设置的默认值
            if (this.isEmpty(this.returnData)) {
                this.returnData = GET_CODE_API_DEFAULT_DATA;
            }
            clearTimeout(this.maxTimer);
        },

        /**
         * 跳转直播间
         * @param {Object} courseInfo 课程信息
         */
        handleJumpLive(courseInfo = {}) {
            this.isFetching = true;
            const params = {
                liveId: courseInfo.liveId,
                isFromH5: false
            };
            this.$axios.$post(api.chunsun.jumpLive, qs.stringify(params)).then(res => {
                const {code = '', data = {}} = res;
                if (code === 0) {
                    const {liveLoginUrl = ''} = data;
                    location.href = liveLoginUrl;
                }
                this.isFetching = false;
            })
                .catch(e => {
                    this.isFetching = false;
                });
        }
    },
};
